import React, { useCallback, useEffect, useMemo, useState } from 'react'
import {
    useTable, useGlobalFilter, usePagination, useSortBy,
    useRowSelect, Column, UseSortByColumnOptions, TableOptions,
    UseFiltersOptions, CellProps, Cell, useFilters, UseFiltersColumnOptions,
    UseFiltersColumnProps, HeaderGroup, FilterType
} from "react-table";
import { ObtenerFechaFormatoGeneralSeparados, ObtenerFechaFromIsoFormat, SumarDiasFecha } from 'helpers/DateFunctions';
import { Row, Col, Table, Input, Button } from "reactstrap";
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';
import { CustomStyleColumnAE, getTdTableStylesAE } from 'helpers/Table/tableFunctionsAE';
import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla';
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos';
import { GetDocumentVistaPrevia, GetDownloadDocument } from 'helpers/files';
import ButtonNoYearsDownloadReportTable from 'components/Varios/Tabla/ComponentButtonNoYearDownload';
import { HistorialFirmaAvisoEntrada } from '../TypesFirmaAvisoEntrada';
import { classNameDownload } from 'constants/Icons-Font-Awesome';
import { authenticationService } from 'services/authentication.service';
import TooltipItem from 'components/Varios/Tooltip';
import ButtonDownloadReportTable from 'components/Varios/Tabla/ComponentButtonExcel';
import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"

type PropsTablaHistorialAvisoSalida = {
    informacion: HistorialFirmaAvisoEntrada[],
    apiReporte: string,
    anioSeleccionado: number,
    apiYearsReporte: string,
    onChangeAnio: (anio: number) => void
}

export default function TablaHistorialAvisoSalida(props: PropsTablaHistorialAvisoSalida) {

    type typeInformacion = HistorialFirmaAvisoEntrada;
    type typeColumna = Column<typeInformacion> & UseFiltersOptions<typeInformacion>

    const informacion = useMemo(() => [...props.informacion], [props.informacion])

    const CellDescargarElemento = (celda: CellProps<HistorialFirmaAvisoEntrada, string | undefined>) => {
        return (
            <div className="containerAvisoEntrada">
            <i
                data-toggle="tootip" data-placement="top" title="Descargar Documento"
                onClick={() => GetDownloadDocument(celda.value ?? "", authenticationService.currentUserValue.token, "Documento Aviso Entrada")}
            >
                <img
                    src={PdfSVG}
                    className="acciones"
                    alt="Descargar Documento"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Descargar Documento"
                    style={{ width: 24, height: 24 }}
                />
                </i>
            </div>
        )
    }

    const columnas = useMemo<readonly typeColumna[]>(() => [
        {
            Header: "Identificación",
            accessor: "numeroIdentificacion",
        },
        {
            Header: "Nombre Completo",
            accessor: "nombres",
        },
        {
            Header: "Tipo firma",
            accessor: "tipoFirma"
        },        
        {
            Header: "Fecha Firma Documento",
            accessor: "fechaFirmaFinanciero",
            Cell: (celda: CellProps<typeInformacion, Date | undefined>) => {
                return <div>{celda.value ? ObtenerFechaFromIsoFormat(celda.value.toString()) : ""}</div>;
            }
        },
        {
            Header: "Descargar Documento Aviso Entrada",
            accessor: "refAvisoEntradaFinanciero",
            Cell: (celda: CellProps<typeInformacion, string | undefined>) => {
                return (CellDescargarElemento(celda))
            }
        }
    ], [props.informacion])

    const columnasStyles = (cell: Cell<typeInformacion>): CustomStyleColumnAE[] => {

        const estilos: CustomStyleColumnAE[] = [
            {
                HeaderName: "Identificación",
                StyleHeader: {
                    textAlign: "center",
                }
            },
            {
                HeaderName: "Nombre Completo",
                StyleHeader: {
                    textAlign: "left",
                    width: "270px"
                }
            },            
            {
                HeaderName: "Fecha Firma Documento",
                StyleHeader: {
                    textAlign: "center",
                    width: "200px"
                }
            },
            {
                HeaderName: "Descargar Documento Aviso Salida",
                StyleHeader: {
                    textAlign: "center",
                    width: "250px",
                    fontSize: "18px"
                }
            }
        ]
        return estilos;
    }

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        setPageSize,
        selectedFlatRows,
        visibleColumns,
        prepareRow,
        setColumnOrder,
        allColumns,
        state,
        setGlobalFilter,

    } = useTable(
        {
            data: informacion,
            columns: columnas,
            autoResetSortBy: false,
            autoResetGlobalFilter: false,
            autoResetFilters: false,
        },
        useGlobalFilter,
        useFilters,
        useSortBy,
        usePagination,
    )

    const { globalFilter, pageIndex, pageSize, filters } = state;
    const sizerows = informacion.length;

    const alteredpage = page.map((row, indice) => {
        row.values = { ...row.values, "#": indice + 1 }
        return row;
    })

    const BotonDescargarReporte = useMemo(
        () => {
            var anioForButton = props.anioSeleccionado ?? 0;
            return (
                <ButtonDownloadReportTable
                    api={props.apiReporte}
                    nombreBoton='Reporte Documentos Aviso Entrada Firmados'
                    apiYears={props.apiYearsReporte}
                    onChangeYearNotAsync={(anio) => props.onChangeAnio(anio)}
                    yearElegido={anioForButton}

                />
            )
        }, [props.anioSeleccionado])

    return (
        <React.Fragment>
            <Row>
                <Col xl={12}> 
                <div className="containerBtnAprobacionesVacLic">
                    <GlobalFilterTable
                        filter={globalFilter}
                        setFilter={setGlobalFilter}
                        />
                </div>
                </Col>
            </Row>
            <Row className="justify-content-end mb-1">
                <Col xl={3} lg={3} md={4} sm={12}>
                    {BotonDescargarReporte}
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <Table className={"tablesReact"} responsive {...getTableProps()} style={{ border: 'solid 1px ' }} >
                        <thead>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                        >
                                            {column.render('Header')}
                                            <span>
                                                {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>

                            {alteredpage.map((row, indirow) => {
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map(cell => {
                                            return getTdTableStylesAE(cell, { border: 'solid 1px black', fontSize: "14px" }, indirow, columnasStyles(cell))
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                    <ComponentePaginacionTabla
                        page={page}
                        sizerows={sizerows}
                        canNextPage={canNextPage}
                        canPreviousPage={canPreviousPage}
                        nextPage={nextPage}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                        pageSize={pageSize}
                        previousPage={previousPage}
                        setPageSize={setPageSize}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}